import React from "react";
import "./SubCategoryPage.css";
import { ExposedAPI } from "../../apis/ExposedAPI";
import { withRouter } from "../../withRouter";
import { Icon, LinearProgress, Paper } from "@mui/material";
import { Link } from "react-router-dom";
import ArticleList from "../../components/article/articleList/ArticleList";
import { URL_REDIRECT } from "../../constant/url";
import { slugify } from "../../utils/utils";
import Seo from "../../components/seo";
import { categoryMeta } from "../../utils/meta";
import { breadcrumbJsonLd } from "../../utils/jsonld";

class SubCategoryPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: [],
      underSubCategories: [],
      articles: [],
    };
  }

  componentDidMount() {
    const params = this.props.router.params;
    this.loadArticles(params.categoryName, params.subcategoryName);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.loadArticles(
      this.props.router.params.categoryName,
      this.props.router.params.subcategoryName
    );
  }

  loadArticlesAndSubCategories(categoryName, subCategoryName) {
    let underSubCategories = [];
    let scId;
    let categoriesList = [];
    ExposedAPI.getDistantOrStoredCategories()
      .then((categories) => {
        categoriesList = categories;
        let category = categories.find((cat) => {
          return slugify(cat.label) + "" === categoryName;
        });
        if (!category) {
          this.props.router.navigate("/404", { replace: true });
          return;
        }
        for (let sc of category.subCategories) {
          if (slugify(sc.label) === subCategoryName) {
            underSubCategories = sc.underSubCategories;
            scId = sc.id;
            break;
          }
        }

        if (!scId) {
          this.props.router.navigate("/404", { replace: true });
          return;
        }

        ExposedAPI.getSubCategoryArticles(scId)
          .then((articles) => {
            for (let article of articles) {
              if (article.description.length > 180) {
                article.short_description =
                  article.description.substring(0, 180) + "...";
              } else {
                article.short_description = article.description;
              }

              article.sort_name = article.label.toUpperCase();
              article.sort_brand = article.brandName
                ? article.brandName.toUpperCase()
                : "";
              article.sort_ref = article.crmId.toUpperCase();
              article.sort_cond = article.conditionnement
                ? article.conditionnement.toUpperCase()
                : "";
              article.sort_ht = parseFloat(article.basePrice);
            }
            this.setState({
              breadcrumbs: this.getSubCategoryBreadcrumbs(categoriesList, scId),
              underSubCategories: underSubCategories.sort((a, b) => {
                return a.label < b.label ? -1 : 1;
              }),
              articles: articles,
            });
          })

          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  loadArticles(categoryName, subCategoryName) {
    this.setState({
      breadcrumbs: [],
      articles: [],
      underSubCategories: [],
    });

    this.loadArticlesAndSubCategories(categoryName, subCategoryName);
  }

  getSubCategoryBreadcrumbs(categories, scId) {
    let matchCategory = null;
    let matchSubCategories = null;

    loop: for (let category of categories) {
      for (let subCategory of category.subCategories) {
        if (subCategory.id + "" === scId + "") {
          matchCategory = category;
          matchSubCategories = subCategory;
          break loop;
        }
      }
    }

    return [
      {
        id: "c_" + matchCategory.id,
        label: matchCategory.label,
        link: URL_REDIRECT.categorie + slugify(matchCategory.label),
      },
      {
        id: "sc_" + matchSubCategories.id,
        label: matchSubCategories.label,
        link:
          URL_REDIRECT.categorie +
          slugify(matchCategory.label) +
          "/" +
          slugify(matchSubCategories.label),
      },
    ];
  }

  render() {
    const { breadcrumbs } = this.state;
    const current = breadcrumbs[breadcrumbs.length - 1];
    const meta = current
      ? categoryMeta(current.label, 2, this.state.articles.length)
      : null;
    const trail = breadcrumbs.map((item) => ({
      name: item.label,
      path: item.link,
    }));
    const params = this.props.router.params;

    return (
      <>
        {current && (
          <Seo
            title={meta.title}
            description={meta.description}
            path={`/categories/${params.categoryName}/${params.subcategoryName}`}
            jsonLd={breadcrumbJsonLd(trail)}
          />
        )}
        <div style={{ width: "100%", position: "relative" }}>
          {this.state.breadcrumbs.length === 0 && (
            <LinearProgress
              style={{
                width: "100%",
                position: "absolute",
                left: 0,
                top: 0,
                height: 5,
                color: "#0068B3",
              }}
            />
          )}
          <div
            style={{
              width: "100%",
              minHeight: 54,
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              flexWrap: "wrap",
              paddingLeft: 6,
              paddingRight: 12,
            }}
          >
            {this.state.breadcrumbs.map((bc, index) => {
              const BreadcrumbLabel = index === this.state.breadcrumbs.length - 1 ? "h1" : "span";
              return (
                <div
                  key={"bc_" + bc.id}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    marginLeft: 6,
                  }}
                >
                  <Link
                    style={{ textDecoration: "none", paddingBottom: 2 }}
                    to={bc.link}
                  >
                    <BreadcrumbLabel
                      style={{ color: "#222222", fontSize: 14, margin: 0, fontWeight: "normal" }}
                      className={"breadcrumb-link"}
                    >
                      {bc.label}
                    </BreadcrumbLabel>
                  </Link>
                  {index !== this.state.breadcrumbs.length - 1 && (
                    <Icon style={{ fontSize: 18, marginLeft: 6 }}>
                      {"keyboard_arrow_right"}
                    </Icon>
                  )}
                </div>
              );
            })}
          </div>

          {this.state.underSubCategories.length > 0 && (
            <Paper
              style={{
                width: "100%",
                marginBottom: 12,
                minHeight: 44,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              {this.state.underSubCategories.map((usc) => {
                return (
                  <Link
                    to={`${current.link}/${slugify(usc.label)}`}
                    style={{ textDecoration: "none" }}
                    key={"usc_" + usc.id}
                  >
                    <div
                      style={{
                        height: 44,
                        paddingLeft: 12,
                        paddingRight: 12,
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      className={"usc-hover-link"}
                    >
                      <p
                        style={{
                          color: "#222222",
                          fontSize: 14,
                          margin: 0,
                          textAlign: "center",
                        }}
                      >
                        {usc.label}
                      </p>
                    </div>
                  </Link>
                );
              })}
            </Paper>
          )}

          <ArticleList articles={this.state.articles} />
        </div>
      </>
    );
  }
}

export default withRouter(SubCategoryPage);
